require('./_set-species')('Array');



//////////////////
// WEBPACK FOOTER
// /root/urbanmassage/node_modules/core-js/modules/es6.array.species.js
// module id = 761
// module chunks = 44